<template lang="pug">
text-frame.breadcrumb-list
  .breadcrumb-list__content.font-medium
    template(v-for='breadcrumb in breadcrumbs')
      link-base.breadcrumb-list__content__link(v-if='breadcrumb.location', @click='moveEvent(breadcrumb)') {{ breadcrumb.label }}
      .breadcrumb-list__content__text(v-else) {{ breadcrumb.label }}
      .breadcrumb-list__content__delimiter.text-xlarge {{ delimiter }}
  button-primary.breadcrumb-list__button(v-if='buttonEvent', @click='buttonEvent')
    slot(name='buttonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextFrame from '@/components/atoms/TextFrame.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

/**
 * パンくずリスト
 */
@Component({
  components: {
    TextFrame,
    LinkBase,
    ButtonPrimary,
  },
})
export default class BreadcrumbList extends Vue {
  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  /**
   * パンくず遷移イベント（任意）
   * 遷移先付きのパンくずがなければ指定不要
   */
  @Prop()
  moveEvent?: Function

  /**
   * ボタン押下時のイベント（任意）
   * 指定時のみボタンが表示される
   */
  @Prop()
  buttonEvent?: Function

  // 区切り文字
  private delimiter = CommonCharacterSetting.NEXT_BUTTON
}
</script>

<style lang="stylus" scoped>
.breadcrumb-list
  display flex
  padding 20px
  justify-content space-between
  align-items center
  border-radius 15px
  background var(--color-manager-breadcrumb__background)
  box-shadow 0px 3px 5px 0px var(--color-manager-breadcrumb__shadow)

  &__content
    display flex
    align-items center

    &__text
      padding 5px 12px

    &__link
      padding 5px 12px
      border-radius 12px
      text-decoration none

      &:hover
        background var(--color-manager-breadcrumb-link__hover)

    &__delimiter
      display flex
      justify-content center
      align-items center
      width 24px
      height 24px
      margin-bottom 5px

      &:last-child
        display none

  &__button
    padding 15px 20px
</style>
